import React from "react";
import { Link } from "react-router-dom";
import "../index.css";

const games = [
  { path: "/lettro-with-twitch", name: "Lettro with Twitch", type: "Daily", logo: "/lettro-twitch.png" },
  { path: "/lettro", name: "Lettro", type: "Daily", logo: "/lettro.png" },
];

const GameDirectory = () => (
  <main className="game-container" style={{maxWidth:"500px"}}>
    <img src="/plaay.png" alt="Plaay.nl" style={{maxHeight:"100px"}} />
    <div className="directory-grid">
      {games.map((game) => (
        <Link
          to={game.path}
          key={game.name}
          style={{ textDecoration: "none", color: "inherit" }}
        >
          <div style={{ textAlign: "center" }}>
            <img src={game.logo} alt={game.name} style={{ maxWidth: "100%" }} />
            <div style={{fontSize:"1.5em"}}>{game.name}</div>
            <small style={{opacity:".7"}}>{game.type}</small>
          </div>
        </Link>
      ))}
    </div>
  </main>
);

export default GameDirectory;